var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" I'm a success alert. ")]),_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" I'm an info alert. ")]),_c('v-alert',{attrs:{"type":"warning"}},[_vm._v(" I'm a warning alert. ")]),_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" I'm an error alert. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }